import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IUploadLogConfigurationFieldsFragment = {
  id?: any | null
  projectId: any
  maps?: Array<{
    globeViewId?: any | null
    sitemapId?: any | null
    order?: number | null
  } | null> | null
  savedGroups?: Array<{
    filterNames?: Array<string | null> | null
  } | null> | null
  columnsConfig?: Array<{
    columnId: string
    isHidden: boolean
    isFixed: boolean
  } | null> | null
}

export type IGetUploadLogConfigurationQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IGetUploadLogConfigurationQuery = {
  uploadLogConfiguration?: {
    id?: any | null
    projectId: any
    maps?: Array<{
      globeViewId?: any | null
      sitemapId?: any | null
      order?: number | null
    } | null> | null
    savedGroups?: Array<{
      filterNames?: Array<string | null> | null
    } | null> | null
    columnsConfig?: Array<{
      columnId: string
      isHidden: boolean
      isFixed: boolean
    } | null> | null
  } | null
}

export type ISaveUploadLogConfigurationMutationVariables = Types.Exact<{
  uploadLogConfiguration: Types.IUploadLogConfigurationInput
}>

export type ISaveUploadLogConfigurationMutation = {
  saveUploadLogConfiguration?: {
    id?: any | null
    projectId: any
    maps?: Array<{
      globeViewId?: any | null
      sitemapId?: any | null
      order?: number | null
    } | null> | null
    savedGroups?: Array<{
      filterNames?: Array<string | null> | null
    } | null> | null
    columnsConfig?: Array<{
      columnId: string
      isHidden: boolean
      isFixed: boolean
    } | null> | null
  } | null
}

export type IListenToUploadLogConfigurationSubscriptionVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IListenToUploadLogConfigurationSubscription = {
  uploadLogConfiguration?: {
    id?: any | null
    item?: {
      id?: any | null
      projectId: any
      maps?: Array<{
        globeViewId?: any | null
        sitemapId?: any | null
        order?: number | null
      } | null> | null
      savedGroups?: Array<{
        filterNames?: Array<string | null> | null
      } | null> | null
      columnsConfig?: Array<{
        columnId: string
        isHidden: boolean
        isFixed: boolean
      } | null> | null
    } | null
  } | null
}

export const UploadLogConfigurationFieldsFragmentDoc = gql`
  fragment UploadLogConfigurationFields on UploadLogConfiguration {
    id
    maps {
      globeViewId
      sitemapId
      order
    }
    savedGroups {
      filterNames
    }
    columnsConfig {
      columnId
      isHidden
      isFixed
    }
    projectId
  }
`
export const GetUploadLogConfigurationDocument = gql`
  query GetUploadLogConfiguration($projectId: ObjectId!) {
    uploadLogConfiguration(projectId: $projectId) {
      ...UploadLogConfigurationFields
    }
  }
  ${UploadLogConfigurationFieldsFragmentDoc}
`

/**
 * __useGetUploadLogConfigurationQuery__
 *
 * To run a query within a React component, call `useGetUploadLogConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadLogConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadLogConfigurationQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetUploadLogConfigurationQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetUploadLogConfigurationQuery,
    IGetUploadLogConfigurationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetUploadLogConfigurationQuery,
    IGetUploadLogConfigurationQueryVariables
  >(GetUploadLogConfigurationDocument, options)
}
export function useGetUploadLogConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetUploadLogConfigurationQuery,
    IGetUploadLogConfigurationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetUploadLogConfigurationQuery,
    IGetUploadLogConfigurationQueryVariables
  >(GetUploadLogConfigurationDocument, options)
}
export type GetUploadLogConfigurationQueryHookResult = ReturnType<
  typeof useGetUploadLogConfigurationQuery
>
export type GetUploadLogConfigurationLazyQueryHookResult = ReturnType<
  typeof useGetUploadLogConfigurationLazyQuery
>
export type GetUploadLogConfigurationQueryResult = Apollo.QueryResult<
  IGetUploadLogConfigurationQuery,
  IGetUploadLogConfigurationQueryVariables
>
export const SaveUploadLogConfigurationDocument = gql`
  mutation SaveUploadLogConfiguration(
    $uploadLogConfiguration: UploadLogConfigurationInput!
  ) {
    saveUploadLogConfiguration(
      uploadLogConfiguration: $uploadLogConfiguration
    ) {
      ...UploadLogConfigurationFields
    }
  }
  ${UploadLogConfigurationFieldsFragmentDoc}
`
export type ISaveUploadLogConfigurationMutationFn = Apollo.MutationFunction<
  ISaveUploadLogConfigurationMutation,
  ISaveUploadLogConfigurationMutationVariables
>

/**
 * __useSaveUploadLogConfigurationMutation__
 *
 * To run a mutation, you first call `useSaveUploadLogConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUploadLogConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUploadLogConfigurationMutation, { data, loading, error }] = useSaveUploadLogConfigurationMutation({
 *   variables: {
 *      uploadLogConfiguration: // value for 'uploadLogConfiguration'
 *   },
 * });
 */
export function useSaveUploadLogConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveUploadLogConfigurationMutation,
    ISaveUploadLogConfigurationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveUploadLogConfigurationMutation,
    ISaveUploadLogConfigurationMutationVariables
  >(SaveUploadLogConfigurationDocument, options)
}
export type SaveUploadLogConfigurationMutationHookResult = ReturnType<
  typeof useSaveUploadLogConfigurationMutation
>
export type SaveUploadLogConfigurationMutationResult =
  Apollo.MutationResult<ISaveUploadLogConfigurationMutation>
export type SaveUploadLogConfigurationMutationOptions =
  Apollo.BaseMutationOptions<
    ISaveUploadLogConfigurationMutation,
    ISaveUploadLogConfigurationMutationVariables
  >
export const ListenToUploadLogConfigurationDocument = gql`
  subscription ListenToUploadLogConfiguration($projectId: ObjectId!) {
    uploadLogConfiguration(projectId: $projectId) {
      id
      item {
        ...UploadLogConfigurationFields
      }
    }
  }
  ${UploadLogConfigurationFieldsFragmentDoc}
`

/**
 * __useListenToUploadLogConfigurationSubscription__
 *
 * To run a query within a React component, call `useListenToUploadLogConfigurationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenToUploadLogConfigurationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenToUploadLogConfigurationSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListenToUploadLogConfigurationSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenToUploadLogConfigurationSubscription,
    IListenToUploadLogConfigurationSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenToUploadLogConfigurationSubscription,
    IListenToUploadLogConfigurationSubscriptionVariables
  >(ListenToUploadLogConfigurationDocument, options)
}
export type ListenToUploadLogConfigurationSubscriptionHookResult = ReturnType<
  typeof useListenToUploadLogConfigurationSubscription
>
export type ListenToUploadLogConfigurationSubscriptionResult =
  Apollo.SubscriptionResult<IListenToUploadLogConfigurationSubscription>
